import React, { useEffect, useState } from "react";
import { allUsers, getUsersForSubsite, userTotalCount, getXlsUserReport, unregisteredCount } from '../../reducers/users';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import MSMPagination from '../MSMPagination';
import CreateUserModal from '../modals/CreateUserModal';
import BulkUserModal from '../modals/BulkUserModal';
import Button from "react-bootstrap/Button";
import { Search, PersonCircle, FileEarmarkSpreadsheetFill, PeopleFill, Envelope, PersonFill, PersonFillExclamation } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import UserService from "../../services/user.service";
import Form from "react-bootstrap/Form";
import { Container, Row, Col, Modal, Alert } from "react-bootstrap";
import { getSubsite, getUserCapabilities } from '../../reducers/auth';

const AdminUsers = () => {
  const users = useSelector(allUsers);
  const userStatus = useSelector(state => state.users.status);
  const userTotal = useSelector(userTotalCount);
  const unregistered = useSelector(unregisteredCount);
  const [ modalShow, setModalShow ] = useState(false);
  const [ bulkModalShow, setBulkModalShow ] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [range, setRange] = useState([1,10]);
  const [reload, setReload] = useState(false);
  const [resetPagination, setResetPagination] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedOption, setSelectedOption] = useState("active");
  const [searchTerm, setSearchTerm] = useState("");
  const [isSendingEmails, setIsSendingEmails] = useState(false);
  const [emailResultModal, setEmailResultModal] = useState({ show: false, message: '', success: false });
  const currentSubsite = useSelector(getSubsite);
  const { isAdmin, isSuperAdmin } = useSelector(state => state.auth);
  const userCapabilities = useSelector(getUserCapabilities);

  const canAddUser = isAdmin || isSuperAdmin || userCapabilities?.some(c => c.capabilityName === "ADD_USER");
  const canManageUsersAdmin = isAdmin || isSuperAdmin;

  let perPage = 10;
  
  useEffect(() => {
    if (userStatus === 'idle') {
      dispatch(getUsersForSubsite([range, selectedOption, searchTerm]));
    }
  }, [userStatus, dispatch]);
  
  useEffect(() => {
    dispatch(getUsersForSubsite([range, selectedOption, searchTerm]));
  }, [range, reload, dispatch]);

  let content = "";

  if (userStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (userStatus === 'succeeded') {
    console.log("USER", users);
    content = users.map(user => (
      <div className="user-list-item" onClick={() => {navigate(`../admin/users/${user.id}`);}}>
        <div className="icon">
          {user.registration_id || !user.active ? <PersonFillExclamation size={75} color="#990000"/> : <PersonFill size={75} color="#009900"/>}
        </div>
        <div className="details">
          <span className="title">Username:</span> {user.username}<br/>
          Name: {user.firstname} {user.lastname}<br/>
          {currentSubsite && currentSubsite.paymentOptions && currentSubsite.paymentOptions == "itemlimit" && 
            (<>Item Limit: {user.subsite_balances?.[0]?.balance ?? 0}</>)
          }
          {currentSubsite && currentSubsite.paymentOptions && currentSubsite.paymentOptions !== "itemlimit" && 
            (<>Balance: ${user.subsite_balances?.[0]?.balance ?? 0}</>)
          }
        </div>
      </div>
    ));    
  } else if (userStatus === 'failed') {
    content = <div>error</div>
  }

  const reloadData = (range) => {
    setRange(range);
  }

  const closeModal = (status) => {
    setModalShow(false);
    if(status) setReload(!reload);
  }

  const showModal = () => {
    setModalShow(true);
  }

  const closeBulkModal = (status) => {
    setBulkModalShow(false);
    if(status) setReload(!reload);
  }

  const showBulkModal = () => {
    setBulkModalShow(true);
  }

  const getReport = () => {
    console.log("Getting XLS Report");
    dispatch(getXlsUserReport());
  }

  const sendUnregisteredEmail = async () => {
    setIsSendingEmails(true);
    try {
      var status = await UserService.sendUnregisteredEmailToAll();

      // Show success modal with results
      setEmailResultModal({
        show: true,
        message: status.message || `Successfully queued emails for ${unregistered} unregistered users`,
        success: true
      });

      // Clear any previous message
      setMessage("");

    } catch (error) {
      console.error('Error sending unregistered emails:', error);

      // Show error modal
      setEmailResultModal({
        show: true,
        message: 'Failed to send emails. Please try again.',
        success: false
      });
    } finally {
      setIsSendingEmails(false);
    }
  }
  const handleChange = (e) => {
    setSelectedOption(e.target.value);
    dispatch(getUsersForSubsite([range, e.target.value, searchTerm]));

  };
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target),
      formDataObj = Object.fromEntries(formData.entries());
    console.log(formDataObj);
    setSearchTerm(formDataObj.searchTerm);
    dispatch(getUsersForSubsite([range, selectedOption, formDataObj.searchTerm]));
  }
  return (
    <Container style={{padding: 4}}>
      <Row>
        <Col>
          <h2>Users</h2>
        </Col>
      </Row>
      <Row style={{padding: 4}}>
        <Col>
          {canAddUser && (
            <>
              <Button onClick={showModal}><PersonCircle/ > Add User</Button>&nbsp;
            </>
          )}
          {canManageUsersAdmin && (
            <>
              <Button onClick={showBulkModal}><PeopleFill/ > Bulk Upload Users</Button>&nbsp;
              <Button color="success" onClick={getReport}><FileEarmarkSpreadsheetFill/> Generate Report</Button>&nbsp;
              <Button color="success" onClick={sendUnregisteredEmail} disabled={isSendingEmails}>
                {isSendingEmails ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Sending Emails...
                  </>
                ) : (
                  <>
                    <Envelope className="me-1" /> Send Email to {unregistered} Unregistered Users
                  </>
                )}
              </Button>&nbsp;
            </>
          )}
        </Col>
      </Row>
      {message && (
      <Row style={{padding: 4}}>
      <Col>
      {message}
      </Col>
      </Row>
      )}
      <Row style={{padding: 4}}>
        <Col xs={6}>
        <Form noValidate onSubmit={handleSearchSubmit}>
                  <Form.Group className="nav-form" controlId="formBasicEmail">
                    <Form.Control type="text" placeholder="Search" name="searchTerm" />
                    <Button variant="secondary" type="submit">
                      <Search />
                    </Button>
                  </Form.Group>
                </Form>
                </Col>
      </Row>

                <Row>
                <Col xs={6}>
                <select value={selectedOption} onChange={handleChange}>
        <option value="active">Active Users</option>
        <option value="inactive">Inactive Users</option>
      </select>
        </Col>
      </Row>
      <Row>
        <Col>
          <MSMPagination reload={reloadData} perPage={perPage} total={userTotal} reset={resetPagination} />
        </Col>
      </Row>
      <Row>
        <Col>
        {content}
        </Col>
      </Row>      
      <CreateUserModal show={modalShow} closeModal={closeModal} />
      {canManageUsersAdmin && (
        <BulkUserModal show={bulkModalShow} closeModal={closeBulkModal} />
      )}

      {/* Email Result Modal */}
      <Modal show={emailResultModal.show} onHide={() => setEmailResultModal({ show: false, message: '', success: false })}>
        <Modal.Header closeButton>
          <Modal.Title>
            {emailResultModal.success ? 'Email Queue Success' : 'Email Queue Error'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant={emailResultModal.success ? 'success' : 'danger'}>
            {emailResultModal.message}
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={emailResultModal.success ? 'success' : 'secondary'}
            onClick={() => setEmailResultModal({ show: false, message: '', success: false })}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
export default AdminUsers;

